export const upsellingHc = {
  servicios: {
    accommodation: "Accommodation",
    all: "All",
    state: "Status",
    search: "Search",
    searchPlaceholder: "Guest or booking code…",
    from: "From",
    to: "To",
    today: "Today",
    noDate: "No date",
    clear: "Clear",
    thService: "Service",
    thGuest: "Guest",
    thBooking: "Booking",
    thRequested: "Requested",
    statusConsult: "On request",
    statusRejected: "Rejected",
    statusPaid: "Paid",
    statusPartial: "Partial payment",
    statusApproved: "Approved",
    statusPending: "Pending",
    serviceFallback: "Service",
    openBookingTitle: "Open the booking",
    approve: "Approve",
    reject: "Reject",
    viewBooking: "View booking",
    noRecords: "No records",
    noRecordsFiltered: "No records found with the applied filters.",
    noRequestsYet: "As soon as a guest requests a service it will appear here.",
    chipBreakfast: "Breakfast",
    chipTour: "Tour",
    chipTransport: "Transport",
    chipMore: "And whatever you offer",
    approveTitle: "Approve request",
    amountLabel: "Amount to charge",
    amountFree: "0 = no charge",
    amountHint: "With a payment gateway connected, the guest is sent a <strong>payment link</strong> (WhatsApp + email). If not, they are told they will <strong>pay on arrival</strong>.",
    cancel: "Cancel",
    processing: "Processing…",
    approveAndNotify: "Approve and notify",
    amountInvalid: "Enter a valid amount (0 = no charge).",
    approvedPaymentLink: "Approved. The payment link was sent to the guest (WhatsApp + email).",
    approvedOnArrival: "Approved. The guest will pay on arrival (no gateway connected).",
    approvedNotified: "Approved. The guest has been notified.",
    approveFailed: "The request could not be approved.",
    rejectTitle: "Reject request",
    rejectMessage: "If you reject it, the guest will NOT be charged for this service and will be notified. Reject the request?",
    rejected: "Request rejected. The guest has been notified.",
    rejectFailed: "The request could not be rejected.",
  },
  form: {
    basicTitle: "Basic information",
    basicDesc: "The name and description the guest will see.",
    autoTranslate: "Write it in <strong>your language</strong>. On saving it is translated <strong>automatically</strong> into all languages (Spanish, English, Portuguese, French, German, Italian, Chinese and Arabic); the guest will see their own.",
    selectPlaceholder: "Select…",
    catNightlife: "Nightlife",
    subtitleLabel: "Subtitle",
    optional: "optional",
    subtitlePlaceholder: "A short hook, e.g.: “Live the experience”",
    price: "Price",
    priceDesc: "How this service is charged to the guest.",
    segWithPrice: "With price",
    segWithPriceDesc: "Charged automatically",
    segOnRequest: "On request",
    segOnRequestDesc: "The guest asks, you quote",
    currencyLabel: "Currency",
    currencyHint: "the listing's",
    chargeBy: "Charge by",
    unitPlaceholder: "Choose the mode…",
    unitPerUnit: "Per unit (fixed price)",
    unitPerPerson: "Per person (× guests)",
    unitPerNight: "Per night (× nights)",
    unitPerGroup: "Per group / stay",
    unitPerHour: "Per hour",
    unitHintPerson: "It will be multiplied by the number of guests in the booking.",
    unitHintNight: "It will be multiplied by the number of nights in the booking.",
    unitHintUnit: "Fixed price for each unit the guest buys.",
    unitHintGroup: "Single price for the booking, regardless of people or nights.",
    unitHintHour: "Price per hour booked.",
    unitLabelPerson: "/ per person",
    unitLabelNight: "/ per night",
    unitLabelGroup: "/ per stay",
    unitLabelHour: "/ per hour",
    stockControl: "Control stock",
    inventory: "inventory",
    stockDesc: "For things that run out (e.g. an extra bed or crib): limit the units. They are deducted on their own with each booking and in real time.",
    unitsAvailable: "Units available",
    removeUnitAria: "Remove one unit",
    addUnitAria: "Add one unit",
    stockNoteSoldOut: "At <strong>0</strong> units the service shows as <strong>Sold out</strong> and cannot be added.",
    stockNoteAuto: "When it reaches 0 it will show <strong>Sold out</strong> automatically.",
    stockConsumePerson: "Each booking deducts 1 unit per guest.",
    stockConsumeNight: "Each booking deducts 1 unit per night.",
    stockModeTitle: "How stock works",
    stockModeAvail: "By availability",
    stockModeAvailDesc: "It is occupied only during the stay and released at checkout (crib, extra bed).",
    stockModeProduct: "By product",
    stockModeProductDesc: "It is deducted with each booking and does not come back. You restock it manually.",
    stockUnlimited: "Unlimited stock — no unit limit.",
    photosTitle: "Photos",
    photoMain: "Main",
    makeMainTitle: "Make main",
    removeTitle: "Remove",
    addPhoto: "Add photo",
    addPhotos: "Add photos",
    reorderHint: "Drag to reorder · the first one is shown on the card.",
    whereTitle: "Where is it offered?",
    whereDesc: "Listings where it will be available. No selection = all.",
    selected: "{count} selected",
    all: "All",
    none: "None",
    searchListingPlaceholder: "Search listing…",
    noResults: "No results",
    diffCurrencyTitle: "This listing uses {currency}. A service goes in a single currency.",
    unit: "unit",
    units: "units",
    loadingListings: "Loading listings…",
    previewLabel: "Preview · this is how the guest will see it",
    previewPhoto: "Your main photo",
    previewTitleFallback: "Service name",
    previewDescFallback: "The description you write will appear here so the guest knows what is included.",
    free: "Free",
    soldOut: "Sold out",
    add: "Add",
    remaining: "{count} unit left | {count} units left",
    scopeManaged: "Offered on <strong>all your listings</strong>. Pick which ones from the Services and experiences list.",
    scopeAll: "Available in <strong>all your accommodations</strong>",
    scopeSome: "Available in <strong>{count}</strong> listing | Available in <strong>{count}</strong> listings",
    errNameRequired: "The name is required",
    errCategoryRequired: "The category is required",
    errDescRequired: "The description is required",
    errPriceRequired: "Enter a price (put 0 if it is free).",
    errPriceNegative: "The price cannot be negative.",
    errUnitRequired: "Choose how it is charged (Charge by)",
    errStockRequired: "Indicate how many units are in stock (put 0 if sold out).",
    errProcessing: "Error processing the request.",
  },
  createServicio: {
    subtitle: "Fill in the information and watch the preview in real time.",
    photosDesc: "Add as many as you like · the 1st is the main one · JPG, PNG or WebP.",
    imageRequired: "Upload at least one image.",
  },
  updateServicio: {
    title: "Edit experience or service",
    subtitle: "Update the information and watch the preview in real time.",
    loadingAria: "Loading service",
    photosDesc: "Add or remove as many as you like · the 1st is the main one · JPG, PNG or WebP.",
    save: "Save changes",
    imageRequired: "At least one image must remain.",
    loadFailed: "The service could not be loaded.",
  },
  configUpselling: {
    title: "Cross-selling Settings",
    phoneIntro: "Enter the phone number you want to use to receive service request notifications via WhatsApp",
    saveWhatsapp: "Save WhatsApp",
    editWhatsapp: "Edit WhatsApp",
    mustEnterWhatsapp: "You must enter the WhatsApp",
    swalTitle: "Cross-selling WhatsApp",
    swalText: "You will receive all notifications of the services requested by customers",
    cancel: "Cancel",
    addedSuccess: "WhatsApp added successfully",
  },
};
